import { put, takeEvery } from 'redux-saga/effects';
import { Notify } from '@flexisaf/flexibull2';
import request from 'utils/request';
import urls from 'utils/config';
import { addPortalSuccess, addPortalFailed } from '../actions';
import { PortalActionTypes } from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { API_BASE_URL } = urls || {};

export function* saveAcknowledgementSlipSaga({ payload }) {
  const url = `${API_BASE_URL}/organisation/portal/acknowledgement-slip`;

  const response = yield request({
    method: 'put',
    url,
    data: payload,
  });

  if (response.success) {
    yield put(addPortalSuccess(response.raw));
    Notify({
      title: 'Acknowledgement slip saved',
      status: 'success',
    });
  } else {
    yield put(addPortalFailed(response.message));
    networkErrorHandler(
      response?.statusCode,
      `Failed to save acknowledgement slip: ${response.message}`
    );
  }
}

export function* saveAcknowledgementSlip() {
  yield takeEvery(PortalActionTypes.SAVE_ACKNOWLEDGEMENT_SLIP, saveAcknowledgementSlipSaga);
}
